<div
  *ngIf="router.url != '/dashboard/home'"
  class="relative w-full bg-gradient-to-b from-[#28364080] to-[#051826] rounded-t-[50px] md:rounded-t-[100px] overflow-hidden pt-16 pb-20 px-4"
>
  <!-- CORNER BORDERS -->
  <div
    class="absolute top-0 left-0 w-[80px] h-[80px] md:w-[160px] md:h-[160px] border-t-[3px] md:border-t-[5px] border-l-[3px] md:border-l-[5px] border-white rounded-tl-[50px] md:rounded-tl-[100px] opacity-100"
  ></div>
  <div
    class="absolute top-0 right-0 w-[80px] h-[80px] md:w-[160px] md:h-[160px] border-t-[3px] md:border-t-[5px] border-r-[3px] md:border-r-[5px] border-white rounded-tr-[50px] md:rounded-tr-[100px] opacity-100"
  ></div>
  <div class="max-w-7xl mx-auto">
    <!-- HEADER -->
    <!-- <div class="flex flex-col md:flex-row items-center justify-between gap-6 mb-8">
      <div class="flex items-center gap-4 w-full max-w-[900px]">
        <div class="w-[4px] h-[60px] md:h-[100px] bg-white/50"></div>

        <div class="w-full bg-gradient-to-r from-[#28364080] to-transparent px-4 md:px-6 py-4">
          <h2 class="text-white font-bold text-[20px] sm:text-[28px] md:text-[40px] lg:text-[44px]">
            <span class="text-[#A6B1C2]">Test You</span>Luck,
            <span class="text-[#A6B1C2]"> With Our Lotteries</span>
          </h2>
        </div>
      </div>

     
    </div> -->
    <div
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-4 mt-12 lg:mt-0 w-full"
      [ngClass]="{ 'container mx-auto max-w-7xl': datashow }"
    >
      <!-- ✅ Skeleton Loader -->
      <ng-container *ngIf="isLoading && !showNoDataFlag">
        <div
          *ngFor="let loader of loaderArray; trackBy: trackByIndex"
          class="mt-4 lg:mt-0 min-h-[30vh] lg:min-h-[60vh] flex items-center justify-center"
        >
          <div class="relative w-[305px]">
            <div
              class="border-2 border-[#E7CA96] rounded-[18px] p-6 bg-[#0b1720] animate-pulse space-y-4"
            >
              <div
                class="w-full h-12 bg-gray-700 rounded flex items-center justify-center text-white text-sm sm:text-base font-medium"
              >
                Lottery data loading...
              </div>
              <div class="h-4 w-36 mx-auto bg-gray-700 rounded"></div>
              <div
                class="h-10 w-full max-w-[280px] mx-auto bg-gray-700 rounded"
              ></div>
              <div class="h-6 w-32 mx-auto bg-gray-700 rounded"></div>
              <div class="h-10 w-full bg-gray-700 rounded"></div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="lotteryList.length > 0">
        <div
          class="min-h-[60vh] flex items-center justify-center"
          *ngFor="let card of lotteryList; trackBy: trackById"
        >
          <div
            class="relative w-[310px] min-h-[455px] rounded-[24px] rounded-tl-[8px] overflow-hidden border border-white/20 bg-[radial-gradient(55.68%_55.68%_at_50%_44.32%,rgba(251,188,4,0.4)_0%,rgba(102,144,173,0.32)_67.78%)] shadow-[0px_2px_8px_rgba(0,0,0,0.1),inset_0px_0px_8px_rgba(170,170,170,0.5),inset_0px_0px_0.5px_rgba(255,255,255,0.5)] backdrop-blur-[6px] px-[15px] pt-4 pb-[18px]"
          >
            <div class="text-center mt-[2px]">
              <p class="text-white text-[14px] leading-[17px] font-bold">
                Lucky Streak
              </p>
              <div
                class="mx-auto mt-[2px] h-px w-[146px] bg-gradient-to-r from-transparent via-[#A6B1C2] to-transparent"
              ></div>
            </div>

            <div class="relative mt-[10px] h-[210px]">
              <div class="absolute left-[16px] top-[8px] -rotate-[15deg]">
                <p
                  class="text-white text-[34px] leading-[41px] font-bold uppercase"
                >
                  ${{ card.WinnersAmount }} Cash
                </p>
                <p
                  class="ml-[114px] text-[#FBBC04] text-[14px] leading-[17px] font-bold uppercase"
                >
                  {{ card.LotteryName }}
                </p>
              </div>

              <img loading="lazy"
                src="/Images/customerHome/lottery-card.png"
                alt="Lottery prize"
                class="absolute left-1/2 top-[54px] h-[151px] w-[151px] -translate-x-1/2 object-contain -rotate-[15deg]"
              />
            </div>

            <div class="mt-[2px] px-[2px]">
              <div
                class="flex items-start justify-between text-[#A6B1C2] text-[12px] leading-[15px] font-medium capitalize"
              >
                <div class="text-center">
                  <p>Total Ticket</p>
                  <p class="text-white font-bold mt-[5px]">
                    {{ card.TotalTickets || 100 }}
                  </p>
                </div>
                <div class="text-center">
                  <p>Ticket Price</p>
                  <p class="text-white font-bold mt-[5px]">
                    ${{ card.TicketPrice }}
                  </p>
                </div>
              </div>

              <ng-container *ngIf="card.Status === 'Open'">
                <p
                  class="text-center text-[#A6B1C2] text-[10px] leading-3 font-medium mt-[8px] capitalize"
                >
                  Giveaway ends in:
                </p>

                <div
                  class="mt-[3px] flex items-center justify-center gap-[10px]"
                >
                  <div
                    class="w-[40px] h-[40px] border border-[#A6B1C2] rounded-[4px] text-center py-[5px]"
                  >
                    <p class="text-white text-[14px] leading-[17px] font-bold">
                      {{ card.time?.dd || "29" }}
                    </p>
                    <p
                      class="text-[#A6B1C2] text-[8px] leading-[10px] font-normal mt-[4px]"
                    >
                      Days
                    </p>
                  </div>
                  <div
                    class="w-[40px] h-[40px] border border-[#A6B1C2] rounded-[4px] text-center py-[5px]"
                  >
                    <p class="text-white text-[14px] leading-[17px] font-bold">
                      {{ card.time.hh }}
                    </p>
                    <p
                      class="text-[#A6B1C2] text-[8px] leading-[10px] font-normal mt-[4px]"
                    >
                      Hours
                    </p>
                  </div>
                  <div
                    class="w-[40px] h-[40px] border border-[#A6B1C2] rounded-[4px] text-center py-[5px]"
                  >
                    <p class="text-white text-[14px] leading-[17px] font-bold">
                      {{ card.time.mm }}
                    </p>
                    <p
                      class="text-[#A6B1C2] text-[8px] leading-[10px] font-normal mt-[4px]"
                    >
                      Min
                    </p>
                  </div>
                  <div
                    class="w-[40px] h-[40px] border border-[#A6B1C2] rounded-[4px] text-center py-[5px]"
                  >
                    <p class="text-white text-[14px] leading-[17px] font-bold">
                      {{ card.time.ss }}
                    </p>
                    <p
                      class="text-[#A6B1C2] text-[8px] leading-[10px] font-normal mt-[4px]"
                    >
                      Sec
                    </p>
                  </div>
                </div>
              </ng-container>

              <div
                *ngIf="card.Status === 'Close'"
                class="mt-3 mb-1 bg-[#111118] border border-[#e6d3a8] rounded-xl p-3 text-center text-sm md:text-base"
              >
                <span class="text-white font-semibold"
                  >Get Ready for the Jackpot!</span
                >
              </div>
            </div>

            <div
              class="absolute left-0 bottom-0 h-[72px] w-[90px] border-l-2 border-b-2 border-white rounded-bl-[24px] pointer-events-none"
            ></div>
            <div
              class="absolute right-0 bottom-0 h-[72px] w-[90px] border-r-2 border-b-2 border-white rounded-br-[24px] pointer-events-none"
            ></div>

            <button
              *ngIf="card.Status === 'Open'"
              (click)="BuyTicket(card)"
              class="mt-[18px] mx-auto flex h-[45px] w-[277px] items-center justify-center bg-[#1C5F72] text-white text-[14px] leading-[17px] font-bold shadow-[0px_2px_8px_rgba(0,0,0,0.1),inset_0px_0px_8px_rgba(170,170,170,0.5),inset_0px_0px_0.5px_rgba(255,255,255,0.5)] backdrop-blur-[6px]"
            >
              Buy Now!
            </button>

            <button
              *ngIf="card.Status === 'Open' && card.IsDisabled"
              class="mt-[18px] mx-auto flex h-[45px] w-[277px] items-center justify-center bg-[#1C5F72] text-white text-[14px] leading-[17px] font-bold shadow-[0px_2px_8px_rgba(0,0,0,0.1),inset_0px_0px_8px_rgba(170,170,170,0.5),inset_0px_0px_0.5px_rgba(255,255,255,0.5)] backdrop-blur-[6px] opacity-70 cursor-not-allowed"
            >
              Buying time over
            </button>
            <!-- (click)="AnnounceTicket(card)" -->
            <button
              *ngIf="card.Status === 'Close'"
              class="mt-[18px] mx-auto flex h-[45px] w-[277px] items-center justify-center bg-[#1C5F72] text-white text-[14px] leading-[17px] font-bold shadow-[0px_2px_8px_rgba(0,0,0,0.1),inset_0px_0px_8px_rgba(170,170,170,0.5),inset_0px_0px_0.5px_rgba(255,255,255,0.5)] backdrop-blur-[6px]"
            >
              Closed
            </button>
          </div>
        </div>
      </ng-container>

      <!-- <ng-container *ngIf="lotteryList.length > 0">
      <div
        class="mt-4 lg:mt-0 min-h-[50vh] lg:min-h-[60vh] flex items-center justify-center"
        *ngFor="let card of lotteryList; trackBy: trackById"
      >
        <div class="relative w-[305px]">
          <div
            class="min-h-[300px] border-2 !border-[#A6B1C2] border-t-0 rounded-tr-1 rounded-tl-1 bg-[#13192E] rounded-[10px] pt-10 pb-8 px-6 shadow-[0px_0px_12px_10px_rgba(25,_228,_224,_0.4)] relative clip-diagonal"
          >
            <svg
              class="absolute -top-[38px] -left-[14px] w-[109%] z-0"
              height="61"
              viewBox="0 0 400 61"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17 62Q14 38 33 36H75L111 0H295L330 35H365Q386 35 386 61"
                fill="#13192E"
                stroke="none"
              />

              <path
                d="M17 62Q14 38 33 36H75L111 0H295L330 35H365Q386 35 386 61"
                fill="none"
                stroke="#A6B1C2"
                stroke-width="2"
              />
            </svg>

            <div
              class="absolute -top-[18px] left-1/2 -translate-x-1/2 bg-[#0b1720] border-2 border-[#E7CA96] px-4 py-1 rounded-full shadow-md z-10"
            >
              <span class="text-white font-bold"># {{ card.SrNumber }}</span>
            </div>

            <h2
              class="text-2xl md:text-3xl font-extrabold text-[#E7CA96] tracking-tight text-center mt-4 -mb-2"
            >
              ${{ card.WinnersAmount }}
            </h2>

            <div
              class="w-36 h-0.5 mx-auto my-3 rounded bg-gradient-to-r from-[#e6d3a8] to-[#c4a264]"
            ></div>

            <p class="text-center text-white font-semibold -mt-2 mb-4">
              {{ card.LotteryName }}
            </p>

            <ng-container *ngIf="card.Status === 'Open'">
              <p class="text-center text-sm text-gray-200 -mb-2">
                Time Left to
                <span
                  class="font-semibold bg-gradient-to-r from-[#e6d3a8] to-[#c4a264] bg-clip-text text-transparent"
                >
                  Big Win!
                </span>
              </p>
              <div class="mx-auto mt-2 mb-4 w-full max-w-[280px]">
                <div
                  class="p-[2px] rounded-lg bg-gradient-to-r from-[#e6d3a8] to-[#c4a264]"
                >
                  <div
                    class="flex items-center justify-between bg-[#08101a] rounded-lg px-8 py-2 shadow-inner"
                  >
                    <span class="font-mono text-lg text-[#F6E9D5]">{{
                      card.time.hh
                    }}</span>
                    <span class="font-mono text-lg text-[#F6E9D5]">:</span>
                    <span class="font-mono text-lg text-[#F6E9D5]">{{
                      card.time.mm
                    }}</span>
                    <span class="font-mono text-lg text-[#F6E9D5]">:</span>
                    <span class="font-mono text-lg text-[#F6E9D5]">{{
                      card.time.ss
                    }}</span>
                  </div>
                </div>
              </div>
            </ng-container>

            <div
              *ngIf="card.Status === 'Close'"
              class="mb-6 bg-[#111118] border border-[#e6d3a8] rounded-xl p-3 text-center text-sm md:text-base"
            >
              <span class="text-white font-semibold"
                >Get Ready for the Jackpot!</span
              >
            </div>

            <p
              class="text-center text-lg font-bold bg-gradient-to-r from-[#e6d3a8] to-[#c4a264] bg-clip-text text-transparent"
            >
              Ticket Price
            </p>
            <p
              class="text-center text-3xl font-extrabold text-white mb-6"
              style="font-family: Libre Franklin"
            >
              $ {{ card.TicketPrice }}
            </p>

            <button
              *ngIf="card.Status === 'Open'"
              (click)="BuyTicket(card)"
              class="block w-full py-2 rounded-md font-semibold text-black  --button shadow-md hover:opacity-95 transition"
            >
              Buy Now!
            </button>

            <button
              *ngIf="card.Status === 'Open' && card.IsDisabled"
              class="block w-full py-2 rounded-md font-semibold text-black  --button shadow-md opacity-70 cursor-not-allowed"
            >
              Buying time over
            </button>

            <button
              *ngIf="card.Status === 'Close'"
              class="block w-full py-2 rounded-md font-semibold text-black  --button shadow-md hover:opacity-95 transition"
            >
              See Details
            </button>
          </div>
        </div>
      </div>
    </ng-container> -->

      <!-- <div
      *ngIf="lotteryList.length == 4"
      class="flex justify-center mt-8 mb-6 w-full col-span-full"
    >
      <button
        (click)="toggleShowAllLottery()"
        class="px-6 py-2  --button text-black font-semibold rounded-lg shadow-md hover:opacity-90 transition"
      >
        {{ showAll ? "Show Less" : "Show More" }}
      </button>
    </div> -->
    </div>
  </div>
</div>

<div
  class="text-white py-0 sm:py-6 flex flex-col items-center"
  *ngIf="router.url == '/dashboard/home'"
>
  <!-- <h2
    class="lg:text-[22px] text-white font-libre font-bold text-[18px] leading-[27px]"
    *ngIf="datashow"
  >
    <span class="text-[#19E4E0] border-b-2 border-[#19E4E0]">Luckycrest</span>
    Lotteries
  </h2>
  <h1 class="text-2xl lg:text-[42px] font-bold mt-2" *ngIf="datashow">
    Daily Lottery, Endless Thrills!
  </h1>
  <p
    class="mt-3 text-[12px] lg:text-[16px] text-gray-400 text-center max-w-2xl px-4"
    *ngIf="datashow"
  >
    Pick your numbers and let HighRollers make your day with exciting daily
    draws and winning opportunities.
  </p> -->
  <!-- (click)="RedirectToLogin()" -->
  <!-- <div
    class="flex mt-2 lg:mt-8 px-4 py-2 bg-transparent lg:bg-[#1B223B] space-x-4"
    *ngIf="datashow"
  >
    <button
      class="px-5 py-2 rounded-lg font-medium border border-gray-400"
      [class.--button]="activeTab === 'all'"
      [class.text-black]="activeTab === 'all'"
      (click)="activeTab = 'all'"
    >
      All Lotteries
    </button>

    <button
      class="px-5 py-2 rounded-lg font-medium border border-gray-400"
      [class.--button]="activeTab === 'upcoming'"
      [class.text-black]="activeTab === 'upcoming'"
      (click)="activeTab = 'upcoming'"
    >
      Upcoming Lotteries
    </button>
  </div> -->

  <!-- Grid Container -->
  <div
    class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 px-6 gap-y-6 gap-x-4 mt-2 sm:mt-12 lg:mt-0 w-full"
    [ngClass]="{ 'container mx-auto max-w-7xl': datashow }"
  >
    <!-- ✅ Skeleton Loader -->
    <ng-container *ngIf="isLoading && !showNoDataFlag">
      <div
        *ngFor="let loader of loaderArray; trackBy: trackByIndex"
        class="mt-4 lg:mt-0 min-h-[30vh] lg:min-h-[60vh] flex items-center justify-center"
      >
        <div class="relative w-[305px]">
          <div
            class="border-2 border-[#E7CA96] rounded-[18px] p-6 bg-[#0b1720] animate-pulse space-y-4"
          >
            <div
              class="w-full h-12 bg-gray-700 rounded flex items-center justify-center text-white text-sm sm:text-base font-medium"
            >
              Lottery data loading...
            </div>
            <div class="h-4 w-36 mx-auto bg-gray-700 rounded"></div>
            <div
              class="h-10 w-full max-w-[280px] mx-auto bg-gray-700 rounded"
            ></div>
            <div class="h-6 w-32 mx-auto bg-gray-700 rounded"></div>
            <div class="h-10 w-full bg-gray-700 rounded"></div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="lotteryList.length > 0">
      <div
        class="min-h-[60vh] flex items-center justify-center"
        *ngFor="let card of lotteryList; trackBy: trackById"
      >
        <div
          class="relative w-[310px] min-h-[455px] rounded-[24px] rounded-tl-[8px] overflow-hidden border border-white/20 bg-[radial-gradient(55.68%_55.68%_at_50%_44.32%,rgba(251,188,4,0.4)_0%,rgba(102,144,173,0.32)_67.78%)] shadow-[0px_2px_8px_rgba(0,0,0,0.1),inset_0px_0px_8px_rgba(170,170,170,0.5),inset_0px_0px_0.5px_rgba(255,255,255,0.5)] backdrop-blur-[6px] px-[15px] pt-4 pb-[18px]"
        >
          <div class="text-center mt-[2px]">
            <p class="text-white text-[14px] leading-[17px] font-bold">
              Lucky Streak
            </p>
            <div
              class="mx-auto mt-[2px] h-px w-[146px] bg-gradient-to-r from-transparent via-[#A6B1C2] to-transparent"
            ></div>
          </div>

          <div class="relative mt-[10px] h-[210px]">
            <div class="absolute left-[16px] top-[8px] -rotate-[15deg]">
              <p
                class="text-white text-[34px] leading-[41px] font-bold uppercase"
              >
                ${{ card.WinnersAmount }} Cash
              </p>
              <p
                class="ml-[114px] text-[#FBBC04] text-[14px] leading-[17px] font-bold uppercase"
              >
                {{ card.LotteryName }}
              </p>
            </div>

            <img loading="lazy"
              src="/Images/customerHome/lottery-card.png"
              alt="Lottery prize"
              class="absolute left-1/2 top-[54px] h-[151px] w-[151px] -translate-x-1/2 object-contain -rotate-[15deg]"
            />
          </div>

          <div class="mt-[2px] px-[2px]">
            <div
              class="flex items-start justify-between text-[#A6B1C2] text-[12px] leading-[15px] font-medium capitalize"
            >
              <div class="text-center">
                <p>Total Ticket</p>
                <p class="text-white font-bold mt-[5px]">
                  {{ card.TotalTickets || 100 }}
                </p>
              </div>
              <div class="text-center">
                <p>Ticket Price</p>
                <p class="text-white font-bold mt-[5px]">
                  ${{ card.TicketPrice }}
                </p>
              </div>
            </div>

            <ng-container *ngIf="card.Status === 'Open'">
              <p
                class="text-center text-[#A6B1C2] text-[10px] leading-3 font-medium mt-[8px] capitalize"
              >
                Giveaway ends in:
              </p>

              <div class="mt-[3px] flex items-center justify-center gap-[10px]">
                <div
                  class="w-[40px] h-[40px] border border-[#A6B1C2] rounded-[4px] text-center py-[5px]"
                >
                  <p class="text-white text-[14px] leading-[17px] font-bold">
                    {{ card.time?.dd || "29" }}
                  </p>
                  <p
                    class="text-[#A6B1C2] text-[8px] leading-[10px] font-normal mt-[4px]"
                  >
                    Days
                  </p>
                </div>
                <div
                  class="w-[40px] h-[40px] border border-[#A6B1C2] rounded-[4px] text-center py-[5px]"
                >
                  <p class="text-white text-[14px] leading-[17px] font-bold">
                    {{ card.time.hh }}
                  </p>
                  <p
                    class="text-[#A6B1C2] text-[8px] leading-[10px] font-normal mt-[4px]"
                  >
                    Hours
                  </p>
                </div>
                <div
                  class="w-[40px] h-[40px] border border-[#A6B1C2] rounded-[4px] text-center py-[5px]"
                >
                  <p class="text-white text-[14px] leading-[17px] font-bold">
                    {{ card.time.mm }}
                  </p>
                  <p
                    class="text-[#A6B1C2] text-[8px] leading-[10px] font-normal mt-[4px]"
                  >
                    Min
                  </p>
                </div>
                <div
                  class="w-[40px] h-[40px] border border-[#A6B1C2] rounded-[4px] text-center py-[5px]"
                >
                  <p class="text-white text-[14px] leading-[17px] font-bold">
                    {{ card.time.ss }}
                  </p>
                  <p
                    class="text-[#A6B1C2] text-[8px] leading-[10px] font-normal mt-[4px]"
                  >
                    Sec
                  </p>
                </div>
              </div>
            </ng-container>

            <div
              *ngIf="card.Status === 'Close'"
              class="mt-3 mb-1 bg-[#111118] border border-[#e6d3a8] rounded-xl p-3 text-center text-sm md:text-base"
            >
              <span class="text-white font-semibold"
                >Get Ready for the Jackpot!</span
              >
            </div>
          </div>

          <div
            class="absolute left-0 bottom-0 h-[72px] w-[90px] border-l-2 border-b-2 border-white rounded-bl-[24px] pointer-events-none"
          ></div>
          <div
            class="absolute right-0 bottom-0 h-[72px] w-[90px] border-r-2 border-b-2 border-white rounded-br-[24px] pointer-events-none"
          ></div>

          <button
            *ngIf="card.Status === 'Open'"
            (click)="BuyTicket(card)"
            class="mt-[18px] mx-auto flex h-[45px] w-[277px] items-center justify-center bg-[#1C5F72] text-white text-[14px] leading-[17px] font-bold shadow-[0px_2px_8px_rgba(0,0,0,0.1),inset_0px_0px_8px_rgba(170,170,170,0.5),inset_0px_0px_0.5px_rgba(255,255,255,0.5)] backdrop-blur-[6px]"
          >
            Buy Now!
          </button>

          <button
            *ngIf="card.Status === 'Open' && card.IsDisabled"
            class="mt-[18px] mx-auto flex h-[45px] w-[277px] items-center justify-center bg-[#1C5F72] text-white text-[14px] leading-[17px] font-bold shadow-[0px_2px_8px_rgba(0,0,0,0.1),inset_0px_0px_8px_rgba(170,170,170,0.5),inset_0px_0px_0.5px_rgba(255,255,255,0.5)] backdrop-blur-[6px] opacity-70 cursor-not-allowed"
          >
            Buying time over
          </button>
          <!-- (click)="AnnounceTicket(card)" -->
          <button
            *ngIf="card.Status === 'Close'"
            class="mt-[18px] mx-auto flex h-[45px] w-[277px] items-center justify-center bg-[#1C5F72] text-white text-[14px] leading-[17px] font-bold shadow-[0px_2px_8px_rgba(0,0,0,0.1),inset_0px_0px_8px_rgba(170,170,170,0.5),inset_0px_0px_0.5px_rgba(255,255,255,0.5)] backdrop-blur-[6px]"
          >
            Closed
          </button>
        </div>
      </div>
    </ng-container>

    <!-- <ng-container *ngIf="lotteryList.length > 0">
      <div
        class="mt-4 lg:mt-0 min-h-[50vh] lg:min-h-[60vh] flex items-center justify-center"
        *ngFor="let card of lotteryList; trackBy: trackById"
      >
        <div class="relative w-[305px]">
          <div
            class="min-h-[300px] border-2 !border-[#A6B1C2] border-t-0 rounded-tr-1 rounded-tl-1 bg-[#13192E] rounded-[10px] pt-10 pb-8 px-6 shadow-[0px_0px_12px_10px_rgba(25,_228,_224,_0.4)] relative clip-diagonal"
          >
            <svg
              class="absolute -top-[38px] -left-[14px] w-[109%] z-0"
              height="61"
              viewBox="0 0 400 61"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17 62Q14 38 33 36H75L111 0H295L330 35H365Q386 35 386 61"
                fill="#13192E"
                stroke="none"
              />

              <path
                d="M17 62Q14 38 33 36H75L111 0H295L330 35H365Q386 35 386 61"
                fill="none"
                stroke="#A6B1C2"
                stroke-width="2"
              />
            </svg>

            <div
              class="absolute -top-[18px] left-1/2 -translate-x-1/2 bg-[#0b1720] border-2 border-[#E7CA96] px-4 py-1 rounded-full shadow-md z-10"
            >
              <span class="text-white font-bold"># {{ card.SrNumber }}</span>
            </div>

            <h2
              class="text-2xl md:text-3xl font-extrabold text-[#E7CA96] tracking-tight text-center mt-4 -mb-2"
            >
              ${{ card.WinnersAmount }}
            </h2>

            <div
              class="w-36 h-0.5 mx-auto my-3 rounded bg-gradient-to-r from-[#e6d3a8] to-[#c4a264]"
            ></div>

            <p class="text-center text-white font-semibold -mt-2 mb-4">
              {{ card.LotteryName }}
            </p>

            <ng-container *ngIf="card.Status === 'Open'">
              <p class="text-center text-sm text-gray-200 -mb-2">
                Time Left to
                <span
                  class="font-semibold bg-gradient-to-r from-[#e6d3a8] to-[#c4a264] bg-clip-text text-transparent"
                >
                  Big Win!
                </span>
              </p>
              <div class="mx-auto mt-2 mb-4 w-full max-w-[280px]">
                <div
                  class="p-[2px] rounded-lg bg-gradient-to-r from-[#e6d3a8] to-[#c4a264]"
                >
                  <div
                    class="flex items-center justify-between bg-[#08101a] rounded-lg px-8 py-2 shadow-inner"
                  >
                    <span class="font-mono text-lg text-[#F6E9D5]">{{
                      card.time.hh
                    }}</span>
                    <span class="font-mono text-lg text-[#F6E9D5]">:</span>
                    <span class="font-mono text-lg text-[#F6E9D5]">{{
                      card.time.mm
                    }}</span>
                    <span class="font-mono text-lg text-[#F6E9D5]">:</span>
                    <span class="font-mono text-lg text-[#F6E9D5]">{{
                      card.time.ss
                    }}</span>
                  </div>
                </div>
              </div>
            </ng-container>

            <div
              *ngIf="card.Status === 'Close'"
              class="mb-6 bg-[#111118] border border-[#e6d3a8] rounded-xl p-3 text-center text-sm md:text-base"
            >
              <span class="text-white font-semibold"
                >Get Ready for the Jackpot!</span
              >
            </div>

            <p
              class="text-center text-lg font-bold bg-gradient-to-r from-[#e6d3a8] to-[#c4a264] bg-clip-text text-transparent"
            >
              Ticket Price
            </p>
            <p
              class="text-center text-3xl font-extrabold text-white mb-6"
              style="font-family: Libre Franklin"
            >
              $ {{ card.TicketPrice }}
            </p>

            <button
              *ngIf="card.Status === 'Open'"
              (click)="BuyTicket(card)"
              class="block w-full py-2 rounded-md font-semibold text-black  --button shadow-md hover:opacity-95 transition"
            >
              Buy Now!
            </button>

            <button
              *ngIf="card.Status === 'Open' && card.IsDisabled"
              class="block w-full py-2 rounded-md font-semibold text-black  --button shadow-md opacity-70 cursor-not-allowed"
            >
              Buying time over
            </button>

            <button
              *ngIf="card.Status === 'Close'"
              class="block w-full py-2 rounded-md font-semibold text-black  --button shadow-md hover:opacity-95 transition"
            >
              See Details
            </button>
          </div>
        </div>
      </div>
    </ng-container> -->

    <!-- <div
      *ngIf="lotteryList.length == 4"
      class="flex justify-center mt-8 mb-6 w-full col-span-full"
    >
      <button
        (click)="toggleShowAllLottery()"
        class="px-6 py-2  --button text-black font-semibold rounded-lg shadow-md hover:opacity-90 transition"
      >
        {{ showAll ? "Show Less" : "Show More" }}
      </button>
    </div> -->
  </div>

  <!-- <div *ngIf="!isLoading && showNoDataFlag" class="flex justify-center items-center">
    <div class="relative max-w-[405px]">
      <div
        class="border-2 border-[#7de7e5] rounded-[18px] p-6 bg-[#0b1720] text-center flex flex-col items-center justify-center space-y-4 shadow-[0_0_20px_rgba(25,228,224,0.2)]">

        <p class="text-white text-lg font-semibold tracking-wide">
          Stay tuned for new lotteries
        </p>
        <p class="text-gray-400 text-sm max-w-[250px]">
          Please check back later — new lotteries are added soon.
        </p>
      </div>
    </div>
  </div> -->
</div>
